import React from "react";
import {Container, Dropdown, Icon, Image, Menu, Segment} from "semantic-ui-react";
import "../../css/Header.css";
import {NavLink} from "react-router-dom";
import {getUsername, LogoutLink} from "../auth";

const Nav = props => {
    return (
        <NavLink {...props}/>
    );
};

export const Header = props => {
  const imageUrl = "/img/tds.png";

  return (
    <div>
      <Segment id="header-segment" attached>
        <Container id="header-container">
            <Menu id="nav-item" size='large' fixed='top' borderless>
                <Menu.Item as={Nav} to='/' header>
                    <Image size='mini' src={imageUrl} style={{marginRight: '.5em'}}/>
                    <span id='header-app-name'>ICC Tool</span>
                </Menu.Item>
                <Menu.Menu position='right'>
                    <Dropdown item trigger={<span><Icon name='user'/> {getUsername()}</span>}>
                        <Dropdown.Menu>
                            <LogoutLink/>
                            <Dropdown.Item as={Nav} to={'/password-change'}>Change Password</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Menu>
            </Menu>
        </Container>
      </Segment>
    </div>
  );
};
